<button mat-menu-item [matMenuTriggerFor]="languages">
  <i class="fa-solid fa-language"></i>
  <span class="languages-label">{{ 'TRANSLATE.LANGUAGES' | i18next }}</span>
</button>
<mat-menu #languages="matMenu" class="language-menu">
  <button mat-menu-item (click)="changeLanguage('it')">
    <img src="assets/images/languages/it.svg">
    <span>IT</span>
  </button>
  <button mat-menu-item (click)="changeLanguage('en')">
    <img src="assets/images/languages/en.svg">
    <span>EN</span>
  </button>
</mat-menu>
